import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { app } from '../main.js'
import { COUNTRY_CODE_LIST } from '@/constants/index'

Vue.use(Vuex)

const moduleBind = {
  namespaced: true,
  state: {
    phoneCountry: '',
    phone: '',
    otp: '',

    email: '',

    requestParams: null,

    verifyTimestamp: 0
  },
  mutations: {
    updateRequestParams (state, params) {
      state.requestParams = params
    },
    updatePhone (state, payload) {
      state.phoneCountry = payload.phoneCountry
      state.phone = payload.phoneNumber
    },
    updateEmail (state, payload) {
      state.email = payload.email
    },
    updateInputOtp (state, val) {
      state.otp = val
    },
    updateInputCode (state, val) {
      state.code = val
    },
    setVerifyTimestamp (state, val) {
      state.verifyTimestamp = val || Date.now() / 1000 | 0
    },
    setLang (state, payload) {
      app.$i18n.locale = payload
    }
  },
  getters: {
    requestParams: state => {
      return state.requestParams
    },
    fullPhoneNumber: state => {
      return state.phoneCountry + state.phone
    },
    emailAddress: state => {
      return state.email
    },
    verifyTimestamp: state => {
      return state.verifyTimestamp
    }
  },
  actions: {
    setLang ({commit}, payload) {
      commit('setLang', payload)
    },
    setPhoneNumber ({commit}, number) {
      // number: country code + phone number
      for (let code of COUNTRY_CODE_LIST) {
        if (number.startsWith(code)) {
          commit('updatePhone', {
            phoneCountry: code,
            phoneNumber: number.slice(code.length)
          })
          break
        }
      }
    }
  }
}

export default new Vuex.Store({
  modules: {
    bind: moduleBind
  },
  plugins: [createPersistedState({
    paths: ['bind.verifyTimestamp']
  })]
})



// WEBPACK FOOTER //
// ./src/store/index.js